module.exports = __webpack_public_path__ + "static/media/product-img1.a566fa98.png";